export default __webpack_public_path__ + "0404e3980ae425cfa6415eca023da45a.png";